module.exports = __webpack_public_path__ + "static/milestonecardsmain-6d0255991832cf2590e3637bf89098d5.jpeg";